import React from "react";
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Label from "../../Utils/FormInputs/Label";
import Col from "react-bootstrap/Col";
import TextField from "../../Utils/FormInputs/TextField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
import { BackButton } from "../../Utils/FormInputs/BackButton";
import { useEditProformaInvoice } from "./CustomHooks/useEditProformaInvoice";

import {
  AutoCompleteUnControlled,
  AutoCompleteMedicine,
} from "../../Utils/FormInputs/AutoCompleteInput";

import { ErrorMessage } from "../../Utils/styledComponents";
import { BlockNavigationComponent } from "../../Utils/ReusableComponents/BlockNavigationComponent";
import Textarea from "../../Utils/FormInputs/Textarea";

function ProformaInvoiceEdit({ actions, snackbars, match }) {
  const { id } = match.params;

  const {
    submitted,
    stateVariables,
    isPending,
    saveProformaInvoice,
    handleCloseSnackbar,
  } = useEditProformaInvoice(actions, id);

  const {
    customer,
    rows,
    state,
    customers,
    drugs,
    totals,
    handleChangeFormFields,
    handleRetrieveCustomerInfo,
    handleClickCustomer,
    handleRetrieveDrugs,
    handleClickDrug,
    handleChangeRate,
    handleChangeQuantity,
    handleAddRow,
    handleRemoveSpecificRow,
    handleAddFourRows,
    isBlocking,
  } = stateVariables || {};

  const { grand_total_price, n_total } = totals || {};
  const { invoice_date, inva_details } = state || {};

  const { open, variant, message } = snackbars;

  return (
    <>
      <ReusableDashboardHeader
        component="Edit Proforma Invoice"
        heading="Edit Proforma Invoice"
        link="/proforma-invoices"
      />

      <PharmacySnackbar
        open={open}
        variant={variant}
        message={message}
        handleCloseBar={handleCloseSnackbar}
      />

      <div className="mb-4">
        <BackButton text="Proforma List" to="/proforma-invoices" />
      </div>

      <BlockNavigationComponent when={isBlocking} />

      <div className="receipt-container p-4">
        <form onSubmit={saveProformaInvoice} autoComplete="off">
          <div className="row mb-4">
            <div className="col-lg-6">
              <Form.Group as={Row} className="mb-3">
                <Col sm="3"><Label name="Bill To" type /></Col>
                <Col sm="9">
                  <AutoCompleteUnControlled
                    options={customers || []}
                    submitted={submitted}
                    handleChange={handleRetrieveCustomerInfo}
                    medicine_value={customer}
                    label_text="customer_name"
                    value_text="customer_id"
                    handleProductData={handleClickCustomer}
                    placeholder="Search customer name..."
                    errorMsg="Customer is required"
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-3">
                <Col sm="3"><Label name="Date" /></Col>
                <Col sm="9">
                  <TextField
                    type="date"
                    name="invoice_date"
                    value={invoice_date}
                    onChange={handleChangeFormFields}
                  />
                  {submitted && !invoice_date && <ErrorMessage>Date is required</ErrorMessage>}
                </Col>
              </Form.Group>
            </div>

            <div className="col-lg-6">
              <Form.Group as={Row} className="mb-3">
                <Col sm="4"><Label name="Grand Total" /></Col>
                <Col sm="8">
                  <TextField 
                    type="text" 
                    value={Number(grand_total_price || 0).toLocaleString()} 
                    readOnly 
                    className="text-right font-weight-bold bg-light"
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-3">
                <Col sm="4"><Label name="Net Total" /></Col>
                <Col sm="8">
                  <TextField 
                    type="text" 
                    value={Number(n_total || 0).toLocaleString()} 
                    readOnly 
                    className="text-right font-weight-bold bg-light"
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Col sm="4"><Label name="Memo" /></Col>
                <Col sm="8">
                  <Textarea
                    name="inva_details"
                    value={inva_details}
                    onChange={handleChangeFormFields}
                    placeholder="Add notes or remarks..."
                    rows={3}
                  />
                </Col>
              </Form.Group>
            </div>
          </div>

          {/* Products Table */}
          <div className="custom-table-container">
            <table className="table table-bordered table-hover">
              <thead className="table-light">
                <tr>
                  <th width="38%">Product</th>
                  <th width="12%">Stock</th>
                  <th width="15%">Rate</th>
                  <th width="15%">Quantity</th>
                  <th width="15%">Total Amount</th>
                  <th width="5%">Action</th>
                </tr>
              </thead>
              <tbody>
                {rows?.map((item, idx) => (
                  <tr key={item.uuid_id || `row-${idx}`}>
                    <td>
                      <AutoCompleteMedicine
                        options={drugs || []}
                        submitted={submitted}
                        idx={idx}
                        handleChange={handleRetrieveDrugs}
                        label_text="label"
                        medicine_value={{ label: item.product_name || "", value: item.product_id || "" }}
                        handleProductData={handleClickDrug}
                        placeholder="Search product..."
                      />
                      {submitted && !item.product_name && <ErrorMessage>Product required</ErrorMessage>}
                    </td>

                    <td className="text-center">
                      <TextField type="text" value={item.total_stock || item.available_quantity || 0} readOnly disabled />
                    </td>

                    <td>
                      <TextField
                        type="number"
                        step="0.01"
                        value={item.product_rate || ""}
                        onChange={(e) => handleChangeRate(e, idx)}
                        placeholder="0.00"
                      />
                    </td>

                    <td>
                      <TextField
                        type="number"
                        value={item.product_quantity || ""}
                        onChange={(e) => handleChangeQuantity(e, idx)}
                        placeholder="0"
                      />
                      {submitted && (!item.product_quantity || Number(item.product_quantity) <= 0) && (
                        <ErrorMessage>Qty required</ErrorMessage>
                      )}
                    </td>

                    <td className="text-right font-weight-bold">
                      <TextField
                        type="text"
                        value={Number(item.total_price || 0).toLocaleString()}
                        readOnly
                      />
                    </td>

                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => handleRemoveSpecificRow(idx)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="mt-3">
              <button type="button" onClick={handleAddRow} className="btn pharmacy-gray-btn btn-sm mr-3">
                <FontAwesomeIcon icon={faPlus} className="mr-2" /> Add Line
              </button>
              <button type="button" onClick={handleAddFourRows} className="btn pharmacy-gray-btn btn-sm">
                Add 4 Lines
              </button>
            </div>
          </div>

          <div className="text-right mt-5">
            <button
              type="submit"
              disabled={isPending}
              className="btn pharmacy-btn btn-lg px-5"
            >
              {isPending ? (
                <>
                  <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  Updating Proforma Invoice...
                </>
              ) : (
                "Update Proforma Invoice"
              )}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({ snackbars: state.snackbars });

const mapDispatchToProps = (dispatch) => ({
  actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProformaInvoiceEdit);